import { all, takeEvery, fork, put, call, select, take, race } from 'redux-saga/effects';
import {
  CREATE_FINAL_MARK_STARTED,
  UPDATE_FINAL_MARK_STARTED,
  CREATE_PARTIAL_MARK_STARTED,
  UPDATE_PARTIAL_MARK_STARTED,
  DELETE_PARTIAL_MARK_STARTED,
  CREATE_FINAL_MARK_SUCCESS,
  UPDATE_FINAL_MARK_SUCCESS,
  CREATE_PARTIAL_MARK_SUCCESS,
  UPDATE_PARTIAL_MARK_SUCCESS,
  DELETE_PARTIAL_MARK_SUCCESS,
  CREATE_FINAL_MARK_FAIL,
  UPDATE_FINAL_MARK_FAIL,
  CREATE_PARTIAL_MARK_FAIL,
  UPDATE_PARTIAL_MARK_FAIL,
  DELETE_PARTIAL_MARK_FAIL,
  CREATE_FINAL_MARKS_STARTED,
  UPDATE_FINAL_MARKS_STARTED,
  CREATE_PARTIAL_MARKS_STARTED,
  UPDATE_PARTIAL_MARKS_STARTED,
  DELETE_PARTIAL_MARKS_STARTED,
  CREATE_FINAL_MARKS_SUCCESS,
  UPDATE_FINAL_MARKS_SUCCESS,
  CREATE_PARTIAL_MARKS_SUCCESS,
  UPDATE_PARTIAL_MARKS_SUCCESS,
  DELETE_PARTIAL_MARKS_SUCCESS,
  CREATE_FINAL_MARKS_FAIL,
  UPDATE_FINAL_MARKS_FAIL,
  CREATE_PARTIAL_MARKS_FAIL,
  UPDATE_PARTIAL_MARKS_FAIL,
  DELETE_PARTIAL_MARKS_FAIL,
  DELETE_FINAL_MARK_STARTED,
  DELETE_FINAL_MARK_FAIL,
  DELETE_FINAL_MARK_SUCCESS,
  SIGN_MARKS_START,
  SIGN_MARKS_SUCCESS,
  SIGN_MARKS_FAIL,
  CANCEL_SIGN_MARKS,
  CONFIRM_CODE_START,
  CONFIRM_EMAIL_CODE_SUCCESS,
  CONFIRM_EMAIL_CODE_FAIL,
  CONFIRM_SMS_CODE_SUCCESS,
  CONFIRM_SMS_CODE_FAIL,
  CLOSE_SIGN_MARK_MODAL,
  OPEN_EMPLOYEE_CONFIRM_MARK_MODAL,
  FINAL_CONFIRM_START,
  FINAL_CONFIRM_SUCCESS,
  FINAL_CONFIRM_FAIL,
  EMPLOYEE_CONFIRM_START,
  EMPLOYEE_CONFIRM_SUCCESS,
  EMPLOYEE_CONFIRM_FAIL,
  OPEN_EMPLOYEE_CODE_MARK_MODAL,
  EMPLOYEE_CODE_START,
  EMPLOYEE_CODE_SUCCESS,
  EMPLOYEE_CODE_FAIL,
  EXECUTE_SIGN_MARKS_ERROR_CODE,
  REFRESH_DATA_AFTER_MARKS_SIGNING,
  MarksState,
} from './types';
import { EXECUTE_ACTION_CODE } from '../auth/types';
import { executeErrorCode } from '../auth/actions';
import { AnyAction } from 'redux';
import marksService from '../../services/marks';
import {
  SignMarkDataPackage,
  SignMarkGroupDataPackage,
  BasicUnitData,
  EmailCodeDataResponse,
  SmsCodeDataResponse,
  EmployeeEmailCodeDataResponse,
  SignMarkDataResponse,
} from '../../services/types/marks';
import { RootState } from '../reducers';
import utilityActions from '../utility/actions';
import marksActions from '../marks/actions';
import { NotificationTypes } from '../utility/types';
import { codes } from '../../settings/codes';
import StorageManager from '../../helpers/storageManager';
import { getTabData } from '../dynamicTabs/selectors';
import { refreshSelectedData } from '../dynamicTabs/stronaPrzedmiotu/actions';

import { setLastMarkDateUserConfig } from '../../helpers/lastMarkDate';
import { getUserId, getParentUserId } from '../auth/selectors';

const { showNotification } = utilityActions;
const { executeMarksSigningErrorCode } = marksActions;

//selektory
export const getSigningData = (state: RootState): MarksState['signing'] => state.Marks.signing;
export const getEmployeeConfirmModal = (state: RootState): MarksState['employeeConfirmModal'] => state.Marks.employeeConfirmModal;

export function* createFinalMarkWatcher(): Generator {
  yield takeEvery(CREATE_FINAL_MARK_STARTED, createFinalMark);
}
/**
 * dodawanie oceny końcowej
 *
 * @export
 * @param {AnyAction} action
 * @return {*}  {Generator}
 */
export function* createFinalMark(action: AnyAction): Generator {
  try {
    yield marksService.createFinalMark(action.payload.data);
    yield call(action.payload.refreshDataAction);
    yield put({
      type: CREATE_FINAL_MARK_SUCCESS,
    });
  } catch (error) {
    if (error && error.errorCode) {
      yield put(executeErrorCode(error.errorCode, action, error));
    }
    yield put({
      type: CREATE_FINAL_MARK_FAIL,
    });
  }
}

export function* updateFinalMarkWatcher(): Generator {
  yield takeEvery([UPDATE_FINAL_MARK_STARTED], updateFinalMark);
}
/**
 * edycja oceny końcowej
 *
 * @export
 * @param {AnyAction} action
 * @return {*}  {Generator}
 */
export function* updateFinalMark(action: AnyAction): Generator {
  try {
    yield marksService.updateFinalMark(action.payload.data);
    yield call(action.payload.refreshDataAction);
    yield put({
      type: UPDATE_FINAL_MARK_SUCCESS,
    });
  } catch (error) {
    if (error && error.errorCode) {
      yield put(executeErrorCode(error.errorCode, action, error));
    }
    yield put({
      type: UPDATE_FINAL_MARK_FAIL,
    });
  }
}

export function* createFinalMarksWatcher(): Generator {
  yield takeEvery([CREATE_FINAL_MARKS_STARTED], createFinalMarks);
}
/**
 * dodawanie ocen końcowych
 *
 * @export
 * @param {AnyAction} action
 * @return {*}  {Generator}
 */
export function* createFinalMarks(action: AnyAction): Generator {
  try {
    yield marksService.createFinalMarks(action.payload.data);

    yield call(action.payload.refreshDataAction);
    yield put({
      type: CREATE_FINAL_MARKS_SUCCESS,
    });
  } catch (error) {
    if (error && error.errorCode) {
      yield put(executeErrorCode(error.errorCode, action, error));
    }
    yield put({
      type: CREATE_FINAL_MARKS_FAIL,
    });
  }
}

export function* updateFinalMarksWatcher(): Generator {
  yield takeEvery([UPDATE_FINAL_MARKS_STARTED], updateFinalMarks);
}
/**
 *  edycja ocen końcowych
 *
 * @export
 * @param {AnyAction} action
 * @return {*}  {Generator}
 */
export function* updateFinalMarks(action: AnyAction): Generator {
  try {
    yield marksService.updateFinalMarks(action.payload.data);
    yield call(action.payload.refreshDataAction);
    yield put({
      type: UPDATE_FINAL_MARKS_SUCCESS,
    });
  } catch (error) {
    if (error && error.errorCode) {
      yield put(executeErrorCode(error.errorCode, action, error));
    }
    yield put({
      type: UPDATE_FINAL_MARKS_FAIL,
    });
  }
}

export function* createPartialMarkWatcher(): Generator {
  yield takeEvery([CREATE_PARTIAL_MARK_STARTED], createPartialMark);
}
/**
 *  dodawanie oceny czątkowej
 *
 * @export
 * @param {AnyAction} action
 * @return {*}  {Generator}
 */
export function* createPartialMark(action: AnyAction): Generator {
  try {
    yield marksService.createPartialMark(action.payload.data);
    yield call(action.payload.refreshDataAction);
    yield put({
      type: CREATE_PARTIAL_MARK_SUCCESS,
    });
  } catch (error) {
    if (error && error.errorCode) {
      yield put(executeErrorCode(error.errorCode, action, error));
    }
    yield put({
      type: CREATE_PARTIAL_MARK_FAIL,
    });
  }
}

export function* updatePartialMarkWatcher(): Generator {
  yield takeEvery([UPDATE_PARTIAL_MARK_STARTED], updatePartialMark);
}
/**
 * edycja oceny czątkowej
 *
 * @export
 * @param {AnyAction} action
 * @return {*}  {Generator}
 */
export function* updatePartialMark(action: AnyAction): Generator {
  try {
    yield marksService.updatePartialMark(action.payload.data);
    yield call(action.payload.refreshDataAction);
    yield put({
      type: UPDATE_PARTIAL_MARK_SUCCESS,
    });
  } catch (error) {
    if (error && error.errorCode) {
      yield put(executeErrorCode(error.errorCode, action, error));
    }
    yield put({
      type: UPDATE_PARTIAL_MARK_FAIL,
    });
  }
}

export function* deletePartialMarkWatcher(): Generator {
  yield takeEvery([DELETE_PARTIAL_MARK_STARTED], deletePartialMark);
}
/**
 * usuwanie oceny czątkowej
 *
 * @export
 * @param {AnyAction} action
 * @return {*}  {Generator}
 */
export function* deletePartialMark(action: AnyAction): Generator {
  try {
    yield marksService.deletePartialMark(action.payload.data);
    yield call(action.payload.refreshDataAction);
    yield put({
      type: DELETE_PARTIAL_MARK_SUCCESS,
    });
  } catch (error) {
    if (error && error.errorCode) {
      yield put(executeErrorCode(error.errorCode, action, error));
    }
    yield put({
      type: DELETE_PARTIAL_MARK_FAIL,
    });
  }
}

export function* createPartialMarksWatcher(): Generator {
  yield takeEvery([CREATE_PARTIAL_MARKS_STARTED], createPartialMarks);
}
/**
 * dodawanie oceny czątkowej
 *
 * @export
 * @param {AnyAction} action
 * @return {*}  {Generator}
 */
export function* createPartialMarks(action: AnyAction): Generator {
  try {
    yield marksService.createPartialMarks(action.payload.data);
    yield call(action.payload.refreshDataAction);
    yield put({
      type: CREATE_PARTIAL_MARKS_SUCCESS,
    });
  } catch (error) {
    if (error && error.errorCode) {
      yield put(executeErrorCode(error.errorCode, action, error));
    }
    yield put({
      type: CREATE_PARTIAL_MARKS_FAIL,
    });
  }
}

export function* updatePartialMarksWatcher(): Generator {
  yield takeEvery([UPDATE_PARTIAL_MARKS_STARTED], updatePartialMarks);
}
/**
 * edycja oceny czątkowej
 *
 * @export
 * @param {AnyAction} action
 * @return {*}  {Generator}
 */
export function* updatePartialMarks(action: AnyAction): Generator {
  try {
    yield marksService.updatePartialMarks(action.payload.data);
    yield call(action.payload.refreshDataAction);
    yield put({
      type: UPDATE_PARTIAL_MARKS_SUCCESS,
    });
  } catch (error) {
    if (error && error.errorCode) {
      yield put(executeErrorCode(error.errorCode, action, error));
    }
    yield put({
      type: UPDATE_PARTIAL_MARKS_FAIL,
    });
  }
}

export function* deletePartialMarksWatcher(): Generator {
  yield takeEvery([DELETE_PARTIAL_MARKS_STARTED], deletePartialMarks);
}
/**
 * usuwanie oceny czątkowej
 *
 * @export
 * @param {AnyAction} action
 * @return {*}  {Generator}
 */
export function* deletePartialMarks(action: AnyAction): Generator {
  try {
    yield marksService.deletePartialMarks(action.payload.data);
    yield call(action.payload.refreshDataAction);
    yield put({
      type: DELETE_PARTIAL_MARKS_SUCCESS,
    });
  } catch (error) {
    if (error && error.errorCode) {
      yield put(executeErrorCode(error.errorCode, action, error));
    }
    yield put({
      type: DELETE_PARTIAL_MARKS_FAIL,
    });
  }
}

export function* deleteFinalMarkWatcher(): Generator {
  yield takeEvery([DELETE_FINAL_MARK_STARTED], deleteFinalMark);
}
/**
 * usuwanie oceny czątkowej
 *
 * @export
 * @param {AnyAction} action
 * @return {*}  {Generator}
 */
export function* deleteFinalMark(action: AnyAction): Generator {
  try {
    yield marksService.deleteFinalMark(action.payload.data);
    yield call(action.payload.refreshDataAction);
    yield put({
      type: DELETE_FINAL_MARK_SUCCESS,
    });
  } catch (error) {
    if (error && error.errorCode) {
      yield put(executeErrorCode(error.errorCode, action, error));
    }
    yield put({
      type: DELETE_FINAL_MARK_FAIL,
    });
  }
}

/**
 * usuwanie oceny czątkowej
 *
 * @export
 * @param {AnyAction} action
 * @return {*}  {Generator}
 */

export function* signMarksStartWatcher(): Generator {
  yield takeEvery(SIGN_MARKS_START, signMarksStart);
}
/**
 * podpisywanie oceny / ocen - krok pierwszy
 *
 * @export
 * @param {AnyAction} action
 * @return {*}  {Generator}
 */
export function* signMarksStart(action: AnyAction): Generator {
  const abortController = new AbortController();
  try {
    const {
      semestrAkademicki,
      rokAkademicki,
      wydzialZlecajacyKod,
      przedmiotKod,
      studentList,
    }: // eslint-disable-next-line @typescript-eslint/no-explicit-any
    MarksState['signing'] | any = yield select(getSigningData);
    if (studentList.length < 1) {
      throw new Error('No Marks to sign in redux');
    } else if (studentList.length === 1) {
      const data: SignMarkDataPackage = {
        obligatoryjnaDataWystawienia: studentList[0].obligatoryjnaDataWystawienia,
        ocena: studentList[0].ocena,
        studentAlbum: studentList[0].albumId,
        studentWydzial: studentList[0].studentWydzial,
        semestrAkademicki,
        rokAkademicki,
        wydzialZlecajacyKod,
        przedmiotKod,
        refreshToken: StorageManager.get('refresh_token'),
      };
      const { cancel, response }: any = yield race({
        response: call(marksService.signMarkFirstStep, data, abortController.signal),
        cancel: take(CLOSE_SIGN_MARK_MODAL),
      });
      if (cancel) {
        abortController.abort();
      } else {
        StorageManager.set('id_token', response.data.token, true);
        StorageManager.set('refresh_token', response.data.refreshToken, true);
        yield put({
          type: SIGN_MARKS_SUCCESS,
          payload: { data: response.data },
        });
        yield put({
          type: EXECUTE_ACTION_CODE,
          payload: { code: response.data.actionCode },
        });
      }
    } else if (studentList.length > 1) {
      const data: SignMarkGroupDataPackage = {
        oceny: studentList.map((student: BasicUnitData) => ({
          obligatoryjnaDataWystawienia: student.obligatoryjnaDataWystawienia,
          ocena: student.ocena,
          studentAlbum: student.albumId,
          studentWydzial: student.studentWydzial,
        })),
        semestrAkademicki,
        rokAkademicki,
        przedmiotKod,
        wydzialZlecajacyKod,
        refreshToken: StorageManager.get('refresh_token'),
      };
      const { cancel, response }: any = yield race({
        response: call(marksService.signMarksFirstStep, data, abortController.signal),
        cancel: take(CLOSE_SIGN_MARK_MODAL),
      });
      if (cancel) {
        abortController.abort();
      } else {
        StorageManager.set('id_token', response.data.token, true);
        StorageManager.set('refresh_token', response.data.refreshToken, true);
        yield put({
          type: SIGN_MARKS_SUCCESS,
          payload: { data: response.data },
        });
        yield put({
          type: EXECUTE_ACTION_CODE,
          payload: { code: response.data.actionCode },
        });
      }
      yield put({
        type: CLOSE_SIGN_MARK_MODAL,
      });
    }
  } catch (error) {
    yield put({
      type: SIGN_MARKS_FAIL,
    });
    if (error) {
      yield put(executeMarksSigningErrorCode(error.errorCode, action, error));
    }
  }
}

export function* confirmCodeWatcher(): Generator {
  yield takeEvery(CONFIRM_CODE_START, confirmCode);
}
/**
 * wysyłanie kody sms / email
 *
 * @export
 * @param {AnyAction} action
 * @return {*}  {Generator}
 */
export function* confirmCode(action: AnyAction): Generator {
  const { code, mode } = action.payload;
  try {
    if (mode === 'sms') {
      const response = (yield marksService.signMarksSmsCode({ code })) as SmsCodeDataResponse;
      yield put({
        type: CONFIRM_SMS_CODE_SUCCESS,
      });
      StorageManager.set('id_token', response.data.token, true);
      StorageManager.set('refresh_token', response.data.refreshToken, true);
      yield put({
        type: FINAL_CONFIRM_START,
      });
    } else if (mode === 'email') {
      const response = (yield marksService.signMarksEmailCode(code)) as EmailCodeDataResponse;
      yield put({
        type: CONFIRM_EMAIL_CODE_SUCCESS,
        payload: { list: response.data.list },
      });
      yield put({
        type: OPEN_EMPLOYEE_CONFIRM_MARK_MODAL,
      });
    }
  } catch (error) {
    if (error && error.errorCode) {
      yield put(executeMarksSigningErrorCode(error.errorCode, action, error));
    }
    if (mode === 'sms') {
      yield put({
        type: CONFIRM_SMS_CODE_FAIL,
      });
    } else if (mode === 'email') {
      yield put({
        type: CONFIRM_EMAIL_CODE_FAIL,
      });
    }
  }
}

export function* chooseEmployeeMarkWatcher(): Generator {
  yield takeEvery(EMPLOYEE_CONFIRM_START, chooseEmployeeMark);
}
/**
 * wysyłanie wybranego pracownika
 *
 * @export
 * @param {AnyAction} action
 * @return {*}  {Generator}
 */
export function* chooseEmployeeMark(action: AnyAction): Generator {
  try {
    const { value }: MarksState['employeeConfirmModal'] = (yield select(
      getEmployeeConfirmModal,
    )) as MarksState['employeeConfirmModal'];
    if (value) {
      yield marksService.signMarksChooseEmployee({ pId: value });
      yield put({
        type: EMPLOYEE_CONFIRM_SUCCESS,
      });
      yield put({
        type: OPEN_EMPLOYEE_CODE_MARK_MODAL,
      });
    } else {
      throw new Error('Missing request data in signMarksChooseEmployee service');
    }
  } catch (error) {
    if (error && error.errorCode) {
      yield put(executeMarksSigningErrorCode(error.errorCode, action, error));
    }
    yield put({
      type: EMPLOYEE_CONFIRM_FAIL,
    });
  }
}

export function* employeeCodeMarkWatcher(): Generator {
  yield takeEvery(EMPLOYEE_CODE_START, employeeCodeMark);
}
/**
 * wysyłanie kodu pracownika
 *
 * @export
 * @param {AnyAction} action
 * @return {*}  {Generator}
 */
export function* employeeCodeMark(action: AnyAction): Generator {
  try {
    const response = (yield marksService.signMarksCodeEmployee(action.payload.code)) as EmployeeEmailCodeDataResponse;
    StorageManager.set('id_token', response.data.token, true);
    StorageManager.set('refresh_token', response.data.refreshToken, true);
    yield put({
      type: EMPLOYEE_CODE_SUCCESS,
    });
    yield put({
      type: FINAL_CONFIRM_START,
    });
  } catch (error) {
    if (error && error.errorCode) {
      yield put(executeMarksSigningErrorCode(error.errorCode, action, error));
    }
    yield put({
      type: EMPLOYEE_CODE_FAIL,
    });
  }
}
export function* finalConfirmMarkWatcher(): Generator {
  yield takeEvery(FINAL_CONFIRM_START, finalConfirmMark);
}
/**
 * podpisywanie oceny - finalny etap
 *
 * @export
 * @param {AnyAction} action
 * @return {*}  {Generator}
 */
export function* finalConfirmMark(action: AnyAction): Generator {
  try {
    const {
      semestrAkademicki,
      rokAkademicki,
      przedmiotKod,
      studentList,
      controlSum,
      wydzialZlecajacyKod,
      tabId,
    }: MarksState['signing'] = (yield select(getSigningData)) as MarksState['signing'];
    if (semestrAkademicki && rokAkademicki && przedmiotKod && studentList && wydzialZlecajacyKod && controlSum) {
      const response =
        studentList.length === 1
          ? ((yield marksService.signMarkConfirm({
              obligatoryjnaDataWystawienia: studentList[0].obligatoryjnaDataWystawienia,
              ocena: studentList[0].ocena,
              studentAlbum: studentList[0].albumId,
              studentWydzial: studentList[0].studentWydzial,
              semestrAkademicki,
              rokAkademicki,
              przedmiotKod,
              wydzialZlecajacyKod,
              controlSum,
            })) as SignMarkDataResponse)
          : ((yield marksService.signMarksConfirm({
              semestrAkademicki,
              rokAkademicki,
              przedmiotKod,
              wydzialZlecajacyKod,
              oceny: studentList.map((student: BasicUnitData) => ({
                obligatoryjnaDataWystawienia: student.obligatoryjnaDataWystawienia,
                ocena: student.ocena,
                studentAlbum: student.albumId,
                studentWydzial: student.studentWydzial,
              })),
              controlSum,
            })) as SignMarkDataResponse);
      StorageManager.set('id_token', response.data.token, true);
      StorageManager.set('refresh_token', response.data.refreshToken, true);
      yield put({
        type: FINAL_CONFIRM_SUCCESS,
      });
      yield put(
        showNotification({
          notifType: 'success' as NotificationTypes,
          titleTranslationKey: 'SIGN_MARKS_MODAL_SUCCESS_TITLE',
          bodyTranslationKey: 'SIGN_MARKS_MODAL_SUCCESS_BODY',
        }),
      );
      yield put({
        type: REFRESH_DATA_AFTER_MARKS_SIGNING,
        payload: { tabId, recordsToRefresh: studentList.map(student => student.studentId) },
      });
    } else {
      throw new Error('Missing request data in finalConfirmMark service');
    }
  } catch (error) {
    if (error && error.errorCode) {
      yield put(executeMarksSigningErrorCode(error.errorCode, action, error));
    }
    yield put({
      type: FINAL_CONFIRM_FAIL,
    });
  }
}
export function* refreshDataAfterSigningMarksWatcher(): Generator {
  yield takeEvery(REFRESH_DATA_AFTER_MARKS_SIGNING, refreshDataAfterSigningMarks);
}
/**
 * inicjalizacja odświeżenia danych po podpisaniu ocen
 *
 * @export
 * @param {AnyAction} { payload }
 * @return {*}  {Generator}
 */
export function* refreshDataAfterSigningMarks({ payload }: AnyAction): Generator {
  const { tabId, recordsToRefresh } = payload;
  const { tabType } = (yield select(state => getTabData(state, tabId))) as DynamicTabWithTable<unknown>;
  if (tabType === 'strona-przedmiotu') {
    yield put(refreshSelectedData(tabId, recordsToRefresh));
  }
}
export function* executeSignMarksErrorCodeWatcher(): Generator {
  yield takeEvery(EXECUTE_SIGN_MARKS_ERROR_CODE, executeSignMarksErrorCode);
}
/**
 * obsługa błędów w prociesie podpisywania ocen
 *
 * @export
 * @param {AnyAction} { payload }
 * @return {*}  {Generator}
 */
export function* executeSignMarksErrorCode({ payload }: AnyAction): Generator {
  const code = Number(payload.code);
  switch (code) {
    case codes.WRONG_EMAIL_CODE:
    case codes.WRONG_SMS_CODE:
    case codes.EXPIRED_TOKEN:
      //nie wykonuj akcji domyslnej
      break;
    default:
      yield put({
        type: CANCEL_SIGN_MARKS,
      });
      break;
  }
  yield put(executeErrorCode(code, payload.failedAction, payload.error));
}
export function* memorizeLastSelectedDateWatcher(): Generator {
  yield takeEvery(
    [CREATE_FINAL_MARK_STARTED, UPDATE_FINAL_MARK_STARTED, CREATE_PARTIAL_MARK_STARTED, UPDATE_PARTIAL_MARK_STARTED],
    memorizeLastSelectedDate,
  );
}
/**
 * Zapis ostatnio wybranej daty w local storage
 *
 * @export
 * @param {AnyAction} { payload }
 * @return {*}  {Generator}
 */
export function* memorizeLastSelectedDate({ payload }: AnyAction): Generator {
  const parentUserId = (yield select(getParentUserId)) as AppConfig.User['id'];
  const userId = (yield select(getUserId)) as AppConfig.User['id'];

  const id = parentUserId ?? userId;
  if (id) {
    yield call(setLastMarkDateUserConfig, id, payload.data.obligatoryjnaDataWystawienia);
  }
}

export default function* rootSaga(): Generator {
  yield all([
    fork(updateFinalMarkWatcher),
    fork(createFinalMarkWatcher),
    fork(updateFinalMarksWatcher),
    fork(createFinalMarksWatcher),
    fork(createPartialMarkWatcher),
    fork(updatePartialMarkWatcher),
    fork(deletePartialMarkWatcher),
    fork(deleteFinalMarkWatcher),
    fork(createPartialMarksWatcher),
    fork(updatePartialMarksWatcher),
    fork(deletePartialMarksWatcher),
    fork(signMarksStartWatcher),
    fork(confirmCodeWatcher),
    fork(finalConfirmMarkWatcher),
    fork(chooseEmployeeMarkWatcher),
    fork(employeeCodeMarkWatcher),
    fork(executeSignMarksErrorCodeWatcher),
    fork(refreshDataAfterSigningMarksWatcher),
    fork(memorizeLastSelectedDateWatcher),
  ]);
}
